/* Native Shopify cart and section rendering, with working HTML form fallbacks. */
(() => {
  'use strict';
  const labels = JSON.parse(document.getElementById('VaderFallsSettings')?.textContent || '{}');
  const root = () => window.Shopify?.routes?.root || '/';
  let busy = false;
  let lastCartTrigger = null;
  const status = (message) => { const el = document.getElementById('SiteStatus'); if (el) el.textContent = message; };
  const moneyFormats = new Map();
  const money = (cents, section) => {const locale=section?.dataset.moneyLocale || document.documentElement.lang || 'en',currency=section?.dataset.currency || 'USD',key=locale+currency;if(!moneyFormats.has(key))moneyFormats.set(key,new Intl.NumberFormat(locale,{style:'currency',currency}));return moneyFormats.get(key).format(Number(cents)/100);};
  const drawer = () => document.getElementById('CartDrawer');
  function openCart(trigger) {
    const el = drawer();
    if (!el?.showModal) return false;
    lastCartTrigger = trigger || lastCartTrigger;
    if (!el.open) el.showModal();
    document.body.classList.add('cart-open');
    return true;
  }
  function closeCart() {
    if (drawer()?.open) drawer().close();
    document.body.classList.remove('cart-open');
    lastCartTrigger?.focus?.({ preventScroll: true });
  }
  function syncAddons() {
    const ids = new Set((drawer()?.dataset.addonIds || '').split(',').filter(Boolean));
    document.querySelectorAll('[data-upsell][data-id]').forEach(el => {
      const already = ids.has(el.dataset.id);
      el.dataset.inCart = String(already);
      el.disabled = already;
      el.checked = already;
      const note = el.closest('.upsell-option')?.querySelector('[data-upsell-in-bag]');
      if (note) note.hidden = !already;
    });
    document.querySelectorAll('[data-product-section]').forEach(section => {
      const selected = section.querySelector('[data-variant]:checked,[data-preview-variant]:checked');
      if (selected) updateVariant(section, selected);
    });
  }
  function replaceCart(html) {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const replacement = parsed.getElementById('shopify-section-cart-drawer');
    const existing = document.getElementById('shopify-section-cart-drawer');
    if (!replacement || !existing) return false;
    existing.replaceChildren(...replacement.childNodes);
    const count = drawer()?.dataset.count || '0';
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = count);
    syncAddons();
    document.dispatchEvent(new CustomEvent('vf:cart-rendered'));
    return true;
  }
  async function refreshCart(html) {
    if (replaceCart(html)) return;
    const response = await fetch(`${root()}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Bag refresh failed.');
    const sections = await response.json();
    if (!replaceCart(sections['cart-drawer'])) throw new Error('Bag refresh failed.');
  }
  function updateVariant(section, input) {
    const price = Number(input.dataset.price || 0);
    const compare = Number(input.dataset.compare || 0);
    section.querySelectorAll('[data-current-price],[data-sticky-price]').forEach(el => el.textContent = money(price, section));
    const extras = Array.from(section.querySelectorAll('[data-upsell]:checked:not(:disabled)')).reduce((n, el) => n + Number(el.dataset.price || 0), 0);
    section.querySelectorAll('[data-button-price]').forEach(el => el.textContent = ` — ${money(price + extras, section)}`);
    section.querySelectorAll('[data-sticky-price]').forEach(el => el.textContent = money(price + extras, section));
    const compareEl = section.querySelector('[data-compare-price]');
    if (compareEl) { compareEl.hidden = compare <= price; compareEl.textContent = money(compare, section); }
    const saving = section.querySelector('[data-savings]');
    if (saving) { saving.hidden = compare <= price || compare === 0; saving.textContent = `${labels.save || 'SAVE'} ${compare > 0 ? Math.round(((compare - price) * 1000) / compare) / 10 : 0}%`; }
    const productSavings = `${labels.save || 'SAVE'} ${compare > price && compare > 0 ? Math.round((compare-price)*1000/compare)/10 : 0}%`;
    section.querySelectorAll('[data-purchase-percent],[data-sticky-savings]').forEach(el=>el.textContent=productSavings);
    section.querySelectorAll('[data-purchase-savings],[data-sticky-savings]').forEach(el=>el.hidden=compare<=price||compare<=0);
    if (input.hasAttribute('data-variant')) {
      const available = input.dataset.available === 'true';
      section.querySelectorAll('[data-add-button]').forEach(el => el.disabled = !available);
      section.querySelectorAll('[data-add-label]').forEach(el => el.textContent = available ? (labels.add || 'Add to bag') : (labels.soldOut || 'Sold out'));
      if (document.body.classList.contains('template-product')) {
        const url = new URL(window.location.href); url.searchParams.set('variant', input.value); if(url.href!==window.location.href)history.replaceState({}, '', url);
      }
    }
    section.dispatchEvent(new CustomEvent('vf:variant-changed',{bubbles:true}));
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      section.querySelectorAll('[data-upsell][data-id]').forEach(el => el.disabled = false);
      const selected = section.querySelector('[data-variant]:checked,[data-preview-variant]:checked');
      if (selected) updateVariant(section, selected);
      const add = section.querySelector('.product-form [data-add-button]');
      const sticky = section.querySelector('[data-sticky-buy]');
      if (add && sticky && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          const show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show));
          sticky.querySelectorAll('button').forEach(el => el.tabIndex = show ? 0 : -1);
        }); observer.observe(add);
      }
    });
  }
  document.addEventListener('click', async event => {
    const thumb = event.target.closest('[data-gallery-thumb]');
    if (thumb) {
      const gallery = thumb.closest('[data-gallery]'); const image = gallery.querySelector('[data-gallery-image]');
      image.removeAttribute('srcset'); image.src = thumb.dataset.src; image.alt = thumb.dataset.alt || ''; image.style.objectPosition = thumb.dataset.focal || '50% 50%';
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(el => { const active = el === thumb; el.classList.toggle('is-active', active); el.setAttribute('aria-pressed', String(active)); });
    }
    const cartOpen = event.target.closest('[data-open-cart]');
    if (cartOpen && openCart(cartOpen)) event.preventDefault();
    if (event.target.closest('[data-close-cart]')) closeCart();
    if (event.target === drawer()) { const box = drawer().getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right) closeCart(); }
    const change = event.target.closest('[data-cart-change]');
    if (!change || busy) return;
    busy = true;
    const wasOpen = drawer()?.open;
    change.disabled = true;
    try {
      const response = await fetch(`${root()}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: change.dataset.key, quantity: Number(change.dataset.quantity), sections: ['cart-drawer'] }) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || (labels.updateError || 'Could not update your bag.'));
      await refreshCart(data.sections?.['cart-drawer']);
      if (wasOpen) openCart();
      status(labels.cartUpdated || 'Your bag has been updated.');
    } catch (error) {
      const message = drawer()?.querySelector('[data-cart-error]');
      if (message) { message.textContent = `${error.message} ${labels.checkBag || 'View your bag to confirm the current quantity before trying again.'}`; message.hidden = false; }
    } finally { busy = false; if (change.isConnected) change.disabled = false; }
  });
  document.addEventListener('change', event => {
    const section = event.target.closest('[data-product-section]');
    if (!section) return;
    if (event.target.matches('[data-variant],[data-preview-variant]')) updateVariant(section, event.target);
    if (event.target.matches('[data-upsell]')) { const selected = section.querySelector('[data-variant]:checked,[data-preview-variant]:checked'); if (selected) updateVariant(section, selected); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (busy) return;
    if (!form.checkValidity()) { form.reportValidity(); return; }
    const section = form.closest('[data-product-section]');
    const input = form.querySelector('[data-variant]:checked');
    if (!input || input.disabled || input.dataset.available !== 'true') return;
    busy = true;
    const buttons = section.querySelectorAll('[data-add-button]');
    buttons.forEach(el => { el.disabled = true; el.setAttribute('aria-busy', 'true'); });
    const errorEl = form.querySelector('[data-form-error]'); if (errorEl) errorEl.hidden = true;
    const quantity = Math.max(1, Number(new FormData(form).get('quantity') || 1));
    const items = [{id: Number(input.value), quantity}];
    const selectedAddons = Array.from(form.querySelectorAll('[data-upsell]:checked:not(:disabled)'));
    let payload;
    let added = false;
    try {
      if (selectedAddons.length) {
        const cartResponse = await fetch(`${root()}cart.js`, {headers: {Accept: 'application/json'}});
        if (!cartResponse.ok) throw new Error(labels.updateError || 'Could not confirm your bag.');
        const existingCart = await cartResponse.json();
        const existingIds = new Set(existingCart.items.map(item => Number(item.variant_id || item.id)));
        selectedAddons.forEach(el => { const id = Number(el.dataset.id); if (!existingIds.has(id)) items.push({id, quantity: 1}); });
      }
      payload = {items, sections: ['cart-drawer'], sections_url: window.location.pathname};
      const response = await fetch(`${root()}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'This pack could not be added.');
      added = true;
      await refreshCart(data.sections?.['cart-drawer']);
      if (!openCart(event.submitter || buttons[0])) window.location.assign(`${root()}cart`);
      status(labels.added || 'Added to your bag.');
    } catch (error) {
      if (added) { window.location.assign(`${root()}cart`); return; }
      if (errorEl) { errorEl.textContent = error instanceof TypeError ? 'We could not confirm this update. Open your bag to check before trying again.' : error.message; errorEl.hidden = false; }
    } finally { busy = false; buttons.forEach(el => { el.disabled = false; el.removeAttribute('aria-busy'); }); }
  });
  document.addEventListener('close', event => { if (event.target.id === 'CartDrawer') { document.body.classList.remove('cart-open'); lastCartTrigger?.focus?.({ preventScroll: true }); } }, true);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', () => document.body.classList.remove('cart-open'));
  init();
  syncAddons();
})();
